import React from 'react';
import ReactDOM from 'react-dom';

import App from './app';

import './assets/css/style.css';
import './assets/css/footer.css';
import './assets/css/main.css';
import './assets/css/header.css';
import './assets/css/menu.css';
import './assets/css/upload.css';
import './assets/css/radio.css';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(<App />, document.getElementById('root'));
 